import React, {useEffect} from 'react';
import myemotionhoc from './myemotionhoc';
import {css} from 'emotion';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';

function getFontFamily(themeFontFamily) {
    if (themeFontFamily) {
        return `'${themeFontFamily}','Poppins', 'Helvetica Neue', 'Calibri Light', Roboto, sans-serif !important`;
    }
    return `'Poppins', 'Helvetica Neue', 'Calibri Light', Roboto, sans-serif !important`;

}

const mstyle = ({themefontfamily}) => css`
	font-family: ${getFontFamily(themefontfamily)};
`;


const OutsideContainer = myemotionhoc('div', mstyle);

function mapStateToProps(state) {
    return {
        themeFontCss: state.settings.themeFontCss,
        themeLinkColor: state.settings.themeLinkColor,
        themePrimaryColor: state.settings.themePrimaryColor,
        store_name: state.settings.store_name,
        store_logo: state.settings.store_logo,
        isRtl: state.settings.isRtl,
    };
}

const ThemedMobileToolbar = connect(mapStateToProps)((props) => props.themePrimaryColor &&
    (<Helmet>
        <meta name="theme-color" content={props.themePrimaryColor}/>
        {props.themeLinkColor ? <style>
            {`
            a, .btn-link, a:hover{ 
                 color: ${props.themeLinkColor} !important; 
            }
        `}
        </style> : null
        }
    </Helmet>));

const BrandedManifest = connect(mapStateToProps)(({store_name, themePrimaryColor, store_logo}) => {
    let myDynamicManifest = {
        name: store_name,
        short_name: store_name,
        description: store_name,
        start_url: '/?utm_source=app',
        background_color: themePrimaryColor,
        theme_color: themePrimaryColor,
        icons: [{
            src: store_logo,
            sizes: '256x256',
            type: 'image/png'
        }]
    };
    const stringManifest = JSON.stringify(myDynamicManifest);
    const blob = new Blob([stringManifest], {type: 'application/json'});
    const manifestURL = URL.createObjectURL(blob);
    const selector = document.querySelector('link[rel=manifest]');
    if (selector) selector.setAttribute('href', manifestURL);
    return null;
});

export default connect(mapStateToProps)((props) => {
    return (
        <OutsideContainer className={`min-vh-100 ${props.isRtl ? 'rtl' : ''}`}>
            <ThemedMobileToolbar/>
            <InjectCssVariables themePrimaryColor={props.themePrimaryColor} />
            <BrandedManifest/>
            {
                props.themeFontCss ? <link href={props.themeFontCss} rel="stylesheet" async/> :
                    <link href={'//fonts.googleapis.com/css?family=Poppins'} rel={'stylesheet'} async/>
            }
            {props.children}
        </OutsideContainer>)
});

function InjectCssVariables({themePrimaryColor}){
    useEffect(()=>{
        if(themePrimaryColor) {
            console.log('setting property', themePrimaryColor)
            const root = document.querySelector(':root');
            // root.style.setProperty("--bs-link-color", themePrimaryColor)
            root.style.setProperty("--bs-blue", themePrimaryColor)
            root.style.setProperty("--bs-primary", `${themePrimaryColor} !important`)
            root.style.setProperty("--bs-btn-bg", themePrimaryColor)
            root.style.setProperty("--bs-btn-disabled-bg",`${themePrimaryColor} !important`)
        }
    },[themePrimaryColor])
   return null;
}
